export default "__VITE_ASSET__BzlTbD7I__"